(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/handlers/draw-handlers.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/handlers/draw-handlers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const {
  http
} = svs.isServer ? require('../proxy-handler.es6') : svs.components.lbUtils.apiProxy;
const featureToggle = svs.isServer ? require('../feature-toggle.es6') : svs.components.lbUtils.apiProxy.featureToggle;
const {
  FEATURE_TOGGLE
} = svs.isServer ? require('../constants.es6') : svs.components.lbUtils.apiProxy.constants;
const {
  getDrawName
} = svs.isServer ? trinidad.components.require('utils', 'products') : svs.utils.products;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const logger = getLogger('lb-utils:api-proxy:draw-handlers');
const isValidDrawNumber = drawNumber => /^\d+$/.test(String(drawNumber !== null && drawNumber !== void 0 ? drawNumber : ''));
const isValidProduct = product => Boolean(getDrawName(product));
const config = {
  shouldUseCloud: async options => {
    const isEnabled = await featureToggle(FEATURE_TOGGLE.BOMBEN_DRAWS_CLOUD_API, options);
    return isEnabled;
  },
  allowedProducts: ['bomben'] 
};

const noTransformResolver = async _ref => {
  let {
    data
  } = _ref;
  return data;
};
const drawHandlers = [http.get('/draw/1/:product/draws/:drawNumber/light?include=:include', noTransformResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    validate: _ref2 => {
      let {
        drawNumber,
        product
      } = _ref2;
      return isValidDrawNumber(drawNumber) && isValidProduct(product);
    },
    cloudEndpointTemplate: '/v1/:product/draws/:drawNumber/summary'
  })
}), http.get('/draw/1/:product/draws/light?include=:include', noTransformResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    cloudEndpointTemplate: '/v1/:product/draws/summary'
  })
}), http.get('/draw/1/:product/draws/:drawNumber?include=:include', noTransformResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    validate: _ref3 => {
      let {
        drawNumber,
        product
      } = _ref3;
      return isValidDrawNumber(drawNumber) && isValidProduct(product);
    },
    cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
  })
}), http.get('/draw/1/:product/draws?include=:include', noTransformResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    cloudEndpointTemplate: '/v1/:product/draws'
  })
})];
if (svs.isServer) {
  module.exports = drawHandlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.handlers.drawHandlers', drawHandlers);
}

 })(window);